import { useState } from "react";
import { toast } from "sonner";
import { blockMember } from "@/lib/blocking";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

// Single source of truth for "Block this member?" — every block in the app must go through here.
export default function BlockConfirmDialog({ open, onOpenChange, targetRef, name, onBlocked, onUndone, testid = "block-confirm" }) {
  const [busy, setBusy] = useState(false);
  const block = async (e) => {
    e?.preventDefault?.();
    if (!targetRef) return;
    setBusy(true);
    try {
      await blockMember(targetRef, { name, onBlocked, onUndone });
      onOpenChange(false);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not block.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={`${testid}-dialog`} className="bg-zinc-950 border-white/10 text-white rounded-none max-w-sm" onClick={(e) => e.stopPropagation()}>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-2xl">Block this member?</AlertDialogTitle>
          <AlertDialogDescription className="text-zinc-400 text-sm">
            {name ? <><span className="text-white">{name}</span> won&apos;t</> : "They won&apos;t"} be able to message you, see your content, or find you in Social Meet. You can unblock anytime from Settings → Privacy → Blocked members.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testid}-cancel`} className="rounded-none bg-transparent border-white/15 text-zinc-300 hover:text-white">Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid={`${testid}-confirm`} disabled={busy} onClick={block} className="rounded-none bg-rose-600 hover:bg-rose-500 text-white">{busy ? "Blocking…" : "Block"}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
